import React from 'react';
import { FadeIn } from './ui/FadeIn';
const steps = [{
  title: 'Identificas el bloqueo',
  desc: 'Localizas el chakra donde se esconde tu inseguridad actual.',
  color: 'bg-chakra-root'
}, {
  title: 'Aplicas el MSS',
  desc: 'Realizas la sacudida somática del día para liberar la emoción.',
  color: 'bg-chakra-heart'
}, {
  title: 'Integras el Cambio',
  desc: 'Utilizas las hojas de trabajo para reprogramar tu respuesta mental.',
  color: 'bg-chakra-thirdEye'
}];
export function HowItWorksSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-zinc-900/20" data-id="element-64">
      <div className="max-w-4xl mx-auto" data-id="element-65">
        <FadeIn data-id="element-66">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-16" data-id="element-67">
            Cómo funciona
          </h2>
        </FadeIn>

        <div className="space-y-12 relative" data-id="element-68">
          {/* Connecting line */}
          <div className="absolute left-[27px] top-8 bottom-8 w-px bg-zinc-800 hidden md:block" data-id="element-69" />

          {steps.map((step, i) => <FadeIn key={i} delay={0.1 * i} className="relative flex flex-col md:flex-row gap-6 md:gap-12 items-start" data-id="element-70">
              <div className="flex items-center gap-6 md:w-auto w-full" data-id="element-71">
                <div className={`w-14 h-14 rounded-full flex items-center justify-center text-xl font-bold text-white shrink-0 shadow-[0_0_15px_rgba(255,255,255,0.1)] ${step.color} relative z-10`} data-id="element-72">
                  {i + 1}
                </div>
                <h3 className="text-2xl font-bold md:hidden" data-id="element-73">{step.title}</h3>
              </div>

              <div className="glass-panel p-8 rounded-2xl flex-1 w-full" data-id="element-74">
                <h3 className="text-2xl font-bold mb-3 hidden md:block" data-id="element-75">
                  {step.title}
                </h3>
                <p className="text-lg text-zinc-400 leading-relaxed" data-id="element-76">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}